import { render, staticRenderFns } from "./HomeFractionCountBox.vue?vue&type=template&id=323616b6&scoped=true&lang=pug"
import script from "./HomeFractionCountBox.vue?vue&type=script&lang=ts"
export * from "./HomeFractionCountBox.vue?vue&type=script&lang=ts"
import style0 from "./HomeFractionCountBox.vue?vue&type=style&index=0&id=323616b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323616b6",
  null
  
)

export default component.exports